export default class Student {
  constructor({ id, pessoa, codigo, particularidades }) {
    this.id = pessoa.id;
    this.codigo = codigo;
    this.cpfCnpj = pessoa.cpf_cnpj;
    this.dataNascimento = pessoa.data_nascimento;
    this.nome = pessoa.nome;
    this.matricula = {
      id,
      codigo
    };
    this.endereco = {
      ...pessoa.endereco,
      rua: pessoa.endereco.logradouro
    };
    this.particularidades = particularidades;
  }
}
